//文字コードはutf-8
// モーダル

export function modal() {

  $(function () {
    const $open = $('.jsModalOpen'),
    $close = $('.jsModalClose'),
    $container = $('.jsModalContainer');
    const $body = $('body');

    // Initially hide all modal targets
    $open.each(function () {
      const targetId = $(this).data('target');
      if (targetId) {
        $('#' + targetId).hide();
      }
    });

    // Open modal
    $open.on('click', function (e) {
      e.preventDefault();

      const targetId = $(this).data('target');
      const $targetModal = $('#' + targetId);

      if (($targetModal.length)){
        $container.stop(true, true).fadeIn().css("display", "flex");
        $targetModal.fadeIn();
        $container.data('active-target', targetId);
        $body.addClass('is-lock');
      }
    });

    // Close modal
    $close.on('click', function () {
      const activeTarget = $container.data('active-target');
      if (activeTarget) {
        const $target = $('#' + activeTarget);

        $target.fadeOut();
      }
      $container.fadeOut();
      $body.removeClass('is-lock');
    });


    // Close modal when clicking outside
    $container.on('click', function (e) {
      if (!$(e.target).closest('.modModal__content').length) {
        const activeTarget = $(this).data('active-target');
        if (activeTarget) {
          const $target = $('#' + activeTarget);

          $target.fadeOut();
        }
        $body.removeClass('is-lock');
        $(this).fadeOut();
      }
    });
  });

  // next page modal anchor open
  $(function() {

    const topPage = '/';

    $('.jsAnchor.jsModalOpen').click(function(e) {
      const anchorId = $(this).attr('href').replace('#','');
      const modalId = $(this).data('target');

      // redirect with hash temporarily
      if (window.location.pathname !== topPage) {
        e.preventDefault();
        window.location.href = topPage + '#' + modalId + '|' + anchorId;
        return;
      }
    });

    // top page load
    if (window.location.pathname === topPage) {
      const hash = window.location.hash;
      if (hash && hash.includes('|')) {
        const [modalId, anchorId] = hash.replace('#','').split('|');

        // Open modal
        const $btn = $('.jsModalOpen[data-target="'+modalId+'"]');
        if ($btn.length) $btn.trigger('click');

        // Wait for modal content
        const $modalContent = $('#' + modalId);
        const $scrollContainer = $modalContent.length ? $modalContent : $('html, body');

        const waitForOpacity = setInterval(function() {
          if (parseFloat($modalContent.css('opacity')) >= 1) {
            clearInterval(waitForOpacity);

            // Scroll to anchor inside modal
            const $target = $('#' + anchorId);
            if ($target.length) {
              let position;
              if ($modalContent.length) {
                position = $target.position().top + $modalContent.scrollTop();
              } else {
                position = $target.offset().top - 120;
              }
              $scrollContainer.stop(true).animate({ scrollTop: position }, 400, 'swing');
            }
          }
        }, 20);

        // Clean URL back to /veritas/
        history.replaceState(null, null, topPage);
      }
    }

  });

}